module.exports = __webpack_public_path__ + "img/dodge.bd92650f.png";